import { Component } from "react";

// Iter244 — Friendly guest-facing error boundary. Wraps public pages
// (Player Self-Service, Public Viewer, Helper Redeem) so a runtime
// error shows a helpful fallback instead of whitescreening the shared
// link. Keeps the coach-facing app UNCHANGED.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, message: err?.message || "Unknown error" };
  }

  componentDidCatch(err, info) {
    // Log to console so on-site helpers can screenshot for support.
    // Intentionally silent otherwise — no analytics beacons on guest links.
    // eslint-disable-next-line no-console
    console.error("[Rally-Lab] Guest page crashed:", err, info);
  }

  handleReload = () => {
    try { window.location.reload(); } catch { /* ignore */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="guest-error-boundary"
        className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6"
      >
        <div className="max-w-sm w-full border border-[#333] bg-[#141414] p-6 text-center">
          <div className="text-xs uppercase tracking-widest text-[#FF4500] font-bold">
            Something went wrong
          </div>
          <div className="text-2xl font-extrabold leading-tight mt-2">
            We hit a snag loading this page.
          </div>
          <div className="text-sm text-[#A3A3A3] mt-3">
            Try reloading — your spot is safe. If it keeps happening, ask the desk for a fresh link.
          </div>
          <button
            type="button"
            data-testid="guest-error-reload"
            onClick={this.handleReload}
            className="mt-5 w-full py-3 bg-[#CCFF00] text-black font-bold text-sm uppercase tracking-wider"
          >
            Reload
          </button>
          {this.state.message ? (
            <div className="text-[10px] text-[#525252] mt-4 break-all">
              {this.state.message}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
